import { useProjectTasksMassRoadmapService } from 'nekst-api';
import { useMassUpdateServiceRequired } from 'ui-builder';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import React from 'react';

export function MassRoadmapForm() {
  const roadmapService = useProjectTasksMassRoadmapService();
  const massUpdateService = useMassUpdateServiceRequired();

  return (
    <ConfirmPositiveActionPopup
      title="Mass Update: Portal Roadmap"
      message={'Click "Confirm" to add the Selected Tasks to the Portal Roadmap.'}
      submitFormFunc={async () => {
        await roadmapService.markAsIncludedToRoadmap(massUpdateService.getCheckedIds());
      }}
    />
  );
}
